<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Médicos</h4>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
            >help</span
          >
        </div>
      </div>
    </div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td style="vertical-align: bottom">
              <img
                src=""
                alt="Asistente"
                title="Asistente para la creación de médicos"
                @click="abrirAsistente"
                @mouseover="hoverEffect(true)"
                @mouseleave="hoverEffect(false)"
                :style="imgStyle"
                role="button"
                tabindex="0"
                @keydown.enter="abrirAsistente"
              />
            </td>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td>
              <label for="cedulaBusqueda" class="form-label">Cédula</label
              ><input
                type="text"
                class="form-control"
                id="cedulaBusqueda"
                name="cedulaBusqueda"
                v-model="cedulaBusqueda"
                @input="clearFields('cedula')"
                style="width: 150px; text-transform: uppercase"
                required
              />
            </td>
            <td>
              <label for="nombreBusqueda" class="form-label">Nombre</label
              ><input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                @input="clearFields('nombre')"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td style="vertical-align: bottom">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="buscar()"
                title="Buscar"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
              </button>
            </td>
            <td style="vertical-align: bottom">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td style="vertical-align: bottom">
              <button
                type="submit"
                class="btn btn-light"
                @click="downloadDataAsCsv"
                title="Generar Archivo"
              >
                <span
                  class="material-symbols-outlined"
                  style="font-size: 24px; color: green"
                  >file_save</span
                >
              </button>
            </td>
            <!--             <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td style="vertical-align: bottom;">
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-hover" id="sampleTable">
      <thead>
        <tr>
          <th scope="col">Documento</th>
          <th scope="col">Nombre</th>
          <th scope="col">Especialidad</th>
          <th scope="col">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="medico in datosPaginados"
          :key="medico.idMedico"
          @click="handleRowClick($event, medico.idMedico)"
        >
          <td>{{ medico.personaDocumento }}</td>
          <td>{{ medico.nombreCompleto }}</td>
          <td>{{ medico.especialidadNombre }}</td>
          <td>
            <select
              class="form-select"
              @change="handleAction($event, medico.idMedico)"
            >
              <option disabled selected>Seleccione...</option>
              <option value="editar">Editar</option>
              <option value="detalles">Detalles</option>
              <option value="borrar">Borrar</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example" v-if="!popupAyuda">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label">IdMedico</label>
                  </div>
                  <div class="col-10">
                    <span id="idMedico" class="form-text">{{
                      datoMedico.idMedico
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombreCompleto" class="form-label"
                      >Persona</label
                    >
                  </div>
                  <div class="col-10">
                    <span id="nombreCompleto" class="form-text">{{
                      datoMedico.nombreCompleto
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="especialidadNombre" class="form-label"
                      >Especialidad</label
                    >
                  </div>
                  <div class="col-10">
                    <span id="especialidadNombre" class="form-text">{{
                      datoMedico.especialidadNombre
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="personaDocumento" class="form-label"
                      >Documento Id.</label
                    >
                  </div>
                  <div class="col-10">
                    <span id="personaDocumento" class="form-text">{{
                      datoMedico.personaDocumento
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="documento" class="form-label"
                      >Documento Médico</label
                    >
                  </div>
                  <div class="col-10">
                    <span id="documento" class="form-text">{{
                      datoMedico.documento
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <!--       <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedico" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>Guardar
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="actualizarMedico" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>Actualizar
        </button>
      </div> -->
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import { exportToCsv } from "@/modules/exportDatos.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;

import swal from "sweetalert";
import swal2 from "sweetalert2";
export default {
  props: {
    p_idPersona: {
      type: String,
      required: true,
    },
  },
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      medicos: [],
      datoMedico: {},
      cedulaBusqueda: "",
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      personas: [],
      especialidads: [],
      popupAyuda: false,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
      imgStyle: {
        width: "64px",
        height: "64px",
        cursor: "pointer",
        border: "2px solid blue",
        borderRadius: "8px",
        display: "block",
        transition: "all 0.3s ease-in-out",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    /*     this.fetchPersonas()
    this.fetchEspecialidads() */
  },
  methods: {
    handleRowClick(event, idMedico) {
      if (
        event.target.tagName === "SELECT" ||
        event.target.tagName === "OPTION"
      ) {
        return;
      }
      this.abrirEditar(idMedico);
    },
    handleAction(event, idMedico) {
      const action = event.target.value;
      if (action === "editar") {
        this.abrirModalEditar(idMedico);
      } else if (action === "detalles") {
        this.abrirEditar(idMedico);
      } else if (action === "borrar") {
        this.deleteMedico(idMedico);
      }
      // Restablecer el valor del select a su estado predeterminado
      event.target.value = "Seleccione...";
    },
    downloadDataAsCsv() {
      const dataToExport = this.datosPaginados;
      const headers = [
        "idMedico",
        "idPersona",
        "idEspecialidad",
        "documento",
        "personaDocumento",
        "estado",
        "idEmpresa",
        "nombreCompleto",
        "personaFechaReg",
        "especialidadNombre",
      ];
      exportToCsv("medicos.csv", dataToExport, headers);
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.medicos.length / this.elementosPorPagina);
    },
    clearFields(field) {
      if (field !== "cedula") this.cedulaBusqueda = "";
      if (field !== "nombre") this.nombreBusqueda = "";
    },
    buscar() {
      if (this.cedulaBusqueda) {
        this.getDataPagina(1, "cedula");
      } else if (this.nombreBusqueda) {
        this.getDataPagina(1, "nombre");
      } else {
        this.getDataPaginaTodos(1);
      }
    },
    getDataPagina(noPagina, tipoBusqueda) {
      let url;
      if (tipoBusqueda === "cedula" && this.cedulaBusqueda) {
        url = config.apiBaseUrl + "/vwmedicos/documento?documento=" +
          this.cedulaBusqueda +
          "&idempresa=" +
          window.sessionStorage.getItem("idEmpresa");
      } else if (tipoBusqueda === "nombre" && this.nombreBusqueda) {
        url = config.apiBaseUrl + "/vwmedicos/nombrecompleto?nombrecompleto=" +
          this.nombreBusqueda +
          "&idempresa=" +
          window.sessionStorage.getItem("idEmpresa");
      } else {
        this.getDataPaginaTodos(noPagina);
        return;
      }
      api
        .get(url)
        .then((response) => {
          this.medicos = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.medicos.slice(ini, fin);
        })
        .catch((error) => {
          console.error("Error en la búsqueda:", error);
          swal(
            "Error",
            "No se encontraron datos con los criterios proporcionados.",
            "error"
          );
        });
    },
    getDataPaginaTodos(noPagina) {
      this.cedulaBusqueda = "";
      this.nombreBusqueda = "";
      api.get("/vwmedicos/idempresa/" +
            window.sessionStorage.getItem("idEmpresa")
        )
        .then((response) => {
          this.medicos = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.medicos.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["idPersona", "idEspecialidad", "documento"];
      const requiredFieldsText = ["idPersona", "idEspecialidad", "documento"];
      return validarForm(this.datoMedico, requiredFields, requiredFieldsText);
    },
    /*    
    async guardarMedico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medicos', this.datoMedico)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Medico creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarMedico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medicos', this.datoMedico)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Medico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
*/
    /*     abrirModalCrear(){
      this.modalWindow = true
      this.datoMedico={}
      this.titulo   = 'Crear Médico'
      this.btnCrear = true
      this.btnEditar= false
    }, */
    abrirModalEditar(idMedico) {
      this.modalWindow = true;
      if (idMedico != null) {
        api.get("/vwmedicos/" + idMedico)
          .then((resp) => {
            this.datoMedico = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Información del Médico";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idMedico) {
      if (idMedico != null) {
        //        this.$router.push('/medicoform/'+idMedico)
        this.$router.push("/medico_agenda/" + idMedico);
      }
    },
    /*     abrirAsistente(){
      var contador = 1;
      api.get('/usuarios/disponibles/32/22').then(resp=>{
        contador = resp.data;
      });
      alert("CONTADOR: "+contador);
      if(contador > 0)
        this.$router.push('/medico01');
      else
        swal("Error!", "No se puede crear más usuarios.", "error");
    }, */
    abrirAsistente() {
      // Inicia una petición con axios
      api.get("/usuarios/disponibles/" +
            window.sessionStorage.getItem("idEmpresa") +
            "/" +
            window.sessionStorage.getItem("idSuscripcion")
        )
        .then((resp) => {
          // Actualiza contador con el valor recibido de la respuesta
          var contador = resp.data;

          // Usa contador para determinar el flujo de navegación
          if (contador > 0) {
            this.$router.push("/medico01/0");
          } else {
            // Muestra un error si el contador es 0 o menos
            swal2
              .fire({
                title: "Error!",
                text: "No es posible crear más usuarios médicos. Para habilitar la creación de nuevos usuarios médicos, por favor actualice su plan de suscripción.",
                icon: "error", // Mantenemos "error" porque es una situación de error
                confirmButtonText: "Actualizar Plan",
                showCancelButton: true, // Opcional: dependiendo si quieres permitir cancelar
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  // Aquí puedes redirigir al usuario para actualizar el plan
                  this.$router.push(
                    "/empresaform/" + window.sessionStorage.getItem("idEmpresa")
                  );
                } else {
                  // Opcional: acción si el usuario decide cancelar
                  swal2.fire(
                    "Actualización Pendiente",
                    "Para crear más usuarios, por favor actualice su plan de suscripción.",
                    "info"
                  );
                }
              });
          }
        })
        .catch((error) => {
          // Maneja posibles errores en la petición
          console.error("Error en la petición: ", error);
          swal(
            "Error!",
            "Problema al obtener la cantidad de usuarios.",
            "error"
          );
        });
    },
    async deleteMedico(idMedico) {
      try {
        await api.delete("/medicos/" + idMedico);
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    /*     fetchPersonas() {
      fetch(config.apiBaseUrl + '/vwpersonas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchEspecialidads() {
      fetch(config.apiBaseUrl + '/vwespecialidads')
        .then(response => response.json())
        .then(data => {
          this.especialidads = data;
        })
        .catch(error => {
          console.error('Error fetching especialidads:', error);
        });
    }, */
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    },
    hoverEffect(isHovering) {
      if (isHovering) {
        this.imgStyle.filter = "brightness(1.2)";
        this.imgStyle.transform = "scale(1.1)";
      } else {
        this.imgStyle.filter = "";
        this.imgStyle.transform = "";
      }
    },
  },
};
</script>
<style scoped>
.table-hover tbody tr:hover {
  background-color: #f5f5f5;
  /* o cualquier otro color de fondo que prefieras */
  cursor: pointer;
  /* Cambia el cursor a una mano */
}
img:hover {
  border-color: rgb(253, 209, 13);
  box-shadow: 0px 0px 10px 2px rgb(253, 209, 13);
  transform: translateY(-5px);
}
</style>
